import actionsFile from "./actions";

export default {
  namespaced: false,
  actions: actionsFile,
};
